import styled from 'styled-components';
import { Text } from '~/components/ui/Text';
import caseImage from '../../assets/images/offer_case.png';
import bg from '../../assets/images/offer_dec_bg.png';

const StyledWrapper = styled.div<{ $x: number; $bottom: number }>`
	position: absolute;
	/* Позиция по X совпадает с левым краем карты */
	left: calc(${(props) => props.$x}px * calc(1 / var(--zoom-factor, 1)));
	/* Над верхней кромкой карты с тем же отступом, что между картой и блоком времени */
	bottom: calc(
		${(props) => props.$bottom}px * calc(1 / var(--zoom-factor, 1)) + 20px
	);
	width: 270px;
	/* Высота оффера (100px) + отступ до карты (20px) */
	height: 120px;
	overflow: hidden;
	pointer-events: none;
`;

const StyledContainer = styled.div`
	position: absolute;
	left: 0;
	bottom: 0;
	width: 270px;
	height: 100px;
	background-color: #111314;
	border: 1px solid rgba(255, 255, 255, 0.1);
	border-radius: 10px;
	pointer-events: auto;

	transition: transform 0.3s;
	transform: translateY(120px);

	&.offer-enter {
		transform: translateY(120px);
	}

	&.offer-enter-active,
	&.offer-enter-done,
	&.offer-exit {
		transform: translateY(0);
	}

	&.offer-exit-active {
		transform: translateY(120px);
	}
`;

const StyledInnerContainer = styled.div`
	position: absolute;
	top: 2px;
	left: 2px;
	right: 2px;
	bottom: 2px;
	z-index: 3;
	border-radius: 8px;
	overflow: hidden;
`;

const StyledBg = styled.div`
	position: absolute;
	top: 2px;
	left: 2px;
	right: 2px;
	bottom: 2px;
	z-index: 2;
	border-radius: 8px;
	mask-image: url(${bg});
	mask-size: cover;
	mask-position: center;
	mask-repeat: no-repeat;
`;

const StyledTextContainer = styled.div`
	position: relative;
	width: 175px;
	height: 100%;
	margin-left: 18px;
	display: flex;
	flex-direction: column;
	gap: 10px;
	justify-content: center;
`;

const StyledCaseImage = styled.div`
	position: absolute;
	right: -92px;
	top: 50%;
	transform: translateY(-50%);
	width: 180px;
	height: 180px;
	background-image: url(${caseImage});
	background-size: cover;
	background-position: center;
	background-repeat: no-repeat;
`;

const StyledTimerNumber = styled.div`
	position: absolute;
	right: 18px;
	top: 18px;
	width: 20px;
	height: 20px;
	background-color: #ffffff;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;

	${Text} {
		font-weight: 700;
		font-size: 12px;
		color: #000000;
	}
`;

export {
	StyledBg,
	StyledCaseImage,
	StyledContainer,
	StyledInnerContainer,
	StyledTextContainer,
	StyledTimerNumber,
	StyledWrapper,
};
